import { render, staticRenderFns } from "./PaperPreview.vue?vue&type=template&id=a0fe1ada&scoped=true"
import script from "./PaperPreview.vue?vue&type=script&lang=js"
export * from "./PaperPreview.vue?vue&type=script&lang=js"
import style0 from "./PaperPreview.vue?vue&type=style&index=0&id=a0fe1ada&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fe1ada",
  null
  
)

export default component.exports